(function ($) {

	'use strict';


	$.changepassClickHandler = function(event, lbMarkup = '<div class="lb_changepassword wrapper" />'){
		event.preventDefault();
		
		var $lb = $(lbMarkup);
		var formHtml = $($('#changepassword')).html();
		var $markup = $('<div>' + formHtml + '</div>');
		
		$.loadLightboxJs(function () {
			$lb.lightbox_me_start($markup, {
				closeClick: false,
				onLoad: function () {
					$('#changepwfrm').on('submit', $.changePwFrmHandler);
					$('#cancelbtn').on('click', function(){$lb.trigger('close');});
					$.addPwSwitch();
				},
				onClose: function () {
					$lb.remove();
				}
			});
		});
	};
	
	$.changePwFrmHandler = function(e) {
		e.preventDefault();
		var oldpw = $('#f-oldpw').val();
		var newpw = $('#f-newpw').val();
		var newpwwh = $('#f-newpwwh').val();
		var msgStyle = {'display': 'inline-block', 'padding': '10px', 'line-height': '120%'};
		$.ajax({
			type: 'POST',
			url: '/changepw.php',
			data: 'oldpw=' + oldpw + '&newpw=' + newpw + '&newpwwh=' + newpwwh,
			success: function (status) {
				if (status === 'ok') {
					$('#elems').hide();
					$('#changemsg').html($.i81n.text('PWCHANGED')).css(msgStyle);

					$('#loginimg').closest('li').removeClass('active');
					isMenuDisplayed = false;
				} else {
					$('#changemsg').html('<span>' + status + '</span>').css(msgStyle);

					$('#elems').show();
					$('#f-oldpw, #f-newpw, #f-newpwwh').val('');
					$('#f-oldpw').focus();
				}
			},
			beforeSend: function () {
				$('#elems').hide();
				$('#changemsg').html($.i81n.text('PWCHANGING')).css(msgStyle);
				;
			},
			error: function (jqXHR, textStatus, errorThrown) {
				$('#changemsg').html(textStatus + ': ' + errorThrown).css(msgStyle);
				;
			}
		});
		return false;
	};
	
}(jQuery));